import { DatePicker } from "@mui/x-date-pickers";

import dayjs from "dayjs";
import { useCallback } from "react";

/**
 * DefaultDatePickerInput
 */

type Props = {
  label: string,
  value?: Date | null,
  helperText?: string,
  required?: boolean,
  readOnly?: boolean,
  disabled?: boolean,
  onChange?: (newValue: Date | null) => void,
};

export const DefaultDatePickerInput = ({
  label,
  value,
  helperText,
  required,
  readOnly,
  disabled,
  onChange,
}: Props) => {

  const handleOnChange = useCallback((dt: dayjs.Dayjs | null) => {
    if (dt === null || dt.isValid()) onChange?.(dt?.toDate() ?? null);
  }, [
    onChange,
  ]);

  return (
    <DatePicker
      slotProps={{
        field: {
          clearable: true,
          onClear: () => onChange?.(null),
        },
        textField: {
          label: label,
          size: 'small',
          fullWidth: true,
          required: required,
          error: helperText !== null && helperText !== undefined,
          helperText: helperText,
          disabled: disabled,
        },
      }}
      readOnly={readOnly}
      label={label}
      value={value ? dayjs.utc(value as any).local().startOf('day') : null}
      onChange={handleOnChange} />
  );
}
